import { render, staticRenderFns } from "./coin-pricing.vue?vue&type=template&id=fe0a1420&scoped=true&"
import script from "./coin-pricing.vue?vue&type=script&lang=js&"
export * from "./coin-pricing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe0a1420",
  null
  
)

export default component.exports